// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
var hasFieldRecord = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function () {
        return {
            getField: function (label) {
                return $foreign.unsafeGet(reflectSymbol(label));
            }
        };
    };
};
var getField = function (dict) {
    return dict.getField;
};
export {
    getField,
    hasFieldRecord
};
